import { Injectable } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from "@angular/router";
import { GeneralService } from "app/services/general.service";
import { BlogClass } from "app/shared/blogs";
import { NewsClass } from "app/shared/news";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

// ✅ Blog Resolver
@Injectable({ providedIn: "root" })
export class BlogResolver implements Resolve<BlogClass> {
  constructor(
    private generalService: GeneralService,
    private meta: Meta,
    private title: Title
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<BlogClass> {
    const id = route.params["id"];
    const lang = route.params["lang"];

    return this.generalService.getItem("blogs", id).pipe(
      map((blog: any) => {
        // ✅ Set Page Title
        this.title.setTitle(blog?.title?.[lang] || "Blog");

        // ✅ Set Meta Tags (with correct attributes)
        this.meta.updateTag({
          property: "og:title",
          content: blog?.title?.[lang] || "",
        });
        this.meta.updateTag({
          name: "description",
          content: blog?.metaDescription?.[lang] || "",
        });
        this.meta.updateTag({
          property: "og:description",
          content: blog?.metaDescription?.[lang] || "",
        });
        this.meta.updateTag({
          property: "og:image",
          content: blog?.image?.url || "",
        });

        // ✅ Handle robots tag correctly
        const robots = [
          blog?.noIndex ? "noindex" : "",
          blog?.noFollow ? "nofollow" : "",
        ]
          .filter(Boolean)
          .join(", ");
        if (robots) {
          this.meta.updateTag({ name: "robots", content: robots });
        }

        return blog as BlogClass;
      })
    );
  }
}

// // ✅ Blogs Resolver
// @Injectable({ providedIn: "root" })
// export class BlogsResolver implements Resolve<any[]> {
//   constructor(private generalService: GeneralService) {}

//   resolve(
//     route: ActivatedRouteSnapshot,
//     state: RouterStateSnapshot
//   ): Observable<any[]> {
//     return this.generalService.getItems("blogs");
//   }
// }

// ✅ One News Resolver
@Injectable({ providedIn: "root" })
export class OneNewsResolver implements Resolve<NewsClass> {
  constructor(
    private generalService: GeneralService,
    private meta: Meta,
    private title: Title
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<NewsClass> {
    const id = route.params["id"];
    const lang = route.params["lang"];

    return this.generalService.getItem("news", id).pipe(
      map((news: any) => {
        // ✅ Set Title
        this.title.setTitle(news?.title?.[lang] || "News");

        // ✅ Set Meta Tags
        this.meta.updateTag({
          property: "og:title",
          content: news?.title?.[lang] || "",
        });
        this.meta.updateTag({
          name: "description",
          content: news?.description?.[lang] || "",
        });
        this.meta.updateTag({
          property: "og:description",
          content: news?.description?.[lang] || "",
        });
        this.meta.updateTag({
          property: "og:image",
          content: news?.image?.url || "",
        });

        // ✅ Handle robots
        const robots = [
          news?.noIndex ? "noindex" : "",
          news?.noFollow ? "nofollow" : "",
        ]
          .filter(Boolean)
          .join(", ");
        if (robots) {
          this.meta.updateTag({ name: "robots", content: robots });
        }

        return news as NewsClass;
      })
    );
  }
}

// ✅ News Resolver
// @Injectable({ providedIn: "root" })
// export class NewsResolver implements Resolve<NewsClass[]> {
//   constructor(private generalService: GeneralService) {}

//   resolve(
//     route: ActivatedRouteSnapshot,
//     state: RouterStateSnapshot
//   ): Observable<NewsClass[]> {
//     return this.generalService.getItems("news");
//   }
// }
